import { HttpErrorCodes } from '@shared/enums/error-codes.enum';
import { ComponentRoutesEnum } from '@shared/utils/component-routes';

export const ERROR_CODES_ROUTES_CONFIG: Partial<
	Record<HttpErrorCodes, ComponentRoutesEnum>
> = {
	[HttpErrorCodes.QUEBEC_RESTRICTION]: ComponentRoutesEnum.QUEBEC_RESTRICTION,
	[HttpErrorCodes.AGE_OF_MAJORITY]: ComponentRoutesEnum.AGE_RESTRICTION_BANKING,
	[HttpErrorCodes.PARTY_BUSINESS_EXISTS]:
		ComponentRoutesEnum.GENERIC_ERROR_PAGE,
	[HttpErrorCodes.INVALID_BUSINESS_REGISTRY]:
		ComponentRoutesEnum.QUEBEC_RESTRICTION,
	[HttpErrorCodes.DUPLICATE_SIN]: ComponentRoutesEnum.GENERIC_ERROR_PAGE
};
